import React, { useState, useEffect } from "react";
import copy from "../../assets/images/logo-white-go.png";
import { useSnackbar } from "notistack";

import "./Footer.scss";

const Footer: React.FC = () => {
  return (
    <div className="footer-wrapper ">
      <div className="footer-grid">
        <div>
          <p
            style={{
              fontSize: 25,
              color: "white",
              fontFamily: "var(--font-bold)",
            }}
          >
            Go Drive Auto
          </p>
          <div
            style={{
              fontSize: 16,
              padding: "20px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="./pre-approval">
              Get Pre-Approved
            </a>
          </div>
          <div
            style={{
              fontSize: 16,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="./sell-your-car">
              Sell My Car
            </a>
          </div>
          <div
            style={{
              fontSize: 16,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="./">
              Inventory
            </a>
          </div>

          <div
            style={{
              fontSize: 16,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="https://godriveauto.ca/about">
              About Us
            </a>
          </div>

          <div
            style={{
              fontSize: 16,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="https://forms.gle/bxfoqbz6zqAdSez66">
              Help Centre
            </a>
          </div>
        </div>

        <div>
          <p
            style={{
              fontSize: 25,
              color: "white",
              fontFamily: "var(--font-bold)",
            }}
          >
            Resources
          </p>
     
          <div
            style={{
              fontSize: 16,
              padding: "20px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="https://godriveauto.ca/testimonials">
              Customer Reviews{" "}
            </a>
          </div>
          <div
            style={{
              fontSize: 16,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="https://godriveauto.ca/understanding-car-loans">
              Understanding Car Loans{" "}
            </a>
          </div>

          <div
            style={{
              fontSize: 16,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="https://godriveauto.ca/calculator">
              Car Loan Calculator{" "}
            </a>
          </div>
        </div>


        <div>
          <p
            style={{
              fontSize: 25,
              color: "white",
              fontFamily: "var(--font-bold)",
            }}
          >
            Legal
          </p>
     
          <div
            style={{
              fontSize: 16,
              padding: "20px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="https://godriveauto.ca/terms-of-use">
              Terms of Use
            </a>
          </div>
          <div
            style={{
              fontSize: 16,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="https://godriveauto.ca/privacy-policy">
              Privacy Policy
            </a>
          </div>

        
        </div>

        <div>
          <div
            style={{
              fontSize: 16,
              padding: "0px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <p
              style={{
                fontSize: 25,
                color: "white",
                fontFamily: "var(--font-bold)",
              }}
            >
              Contact Us
            </p>
            <p
  style={{
    fontWeight: 400,
    paddingTop: 20,
    fontSize: 16,
    color: "white",
  }}
>
  Contact Info.
  <br />
  <a href="tel:5195504322" style={{ color: "white", textDecoration: "none" }}>
    519-550-4322
  </a>
  <br />
  <a href="mailto:info@godriveauto.ca" style={{ color: "white", textDecoration: "none" }}>
    info@godriveauto.ca
  </a>
</p>

          </div>
          <div className="media flex-item">
          

            <div
              style={{
                zIndex: 1000,
                width: 40,
                height: 40,
                borderRadius: 5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid white",
              }}
            >
              <a href="https://www.tiktok.com/@go.drive.auto?_t=ZM-8vyLT3B07nj&_r=1" style={{ color: "white" }}>
                <i className="fab fa-tiktok"></i>
              </a>
            </div>

            <div
              style={{
                zIndex: 1000,
                width: 40,
                height: 40,
                borderRadius: 5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid white",
              }}
            >
              <a href="https://www.instagram.com/go.drive.auto?igsh=dDZrdXJwMmlmZW5t&utm_source=qr" style={{ color: "white" }}>
                <i className="fab fa-instagram"></i>
              </a>
            </div>

            <div
              style={{
                zIndex: 1000,
                width: 40,
                height: 40,
                borderRadius: 5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid white",
              }}
            >
              <a href="#" style={{ color: "white" }}>
                <i className="fab fa-facebook"></i>
              </a>
            </div>
          </div>
        </div>

        <div>
          {/* <p style={{ fontSize: 16 }}>PLATFORM</p>
          <div
            style={{
              fontSize: 16,
              padding: "20px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="/">
              Terms
            </a>
          </div>
          <div
            style={{
              fontSize: 16,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "white" }} href="/">
              Privacy
            </a>
          </div> */}
        </div>
      </div>

      <hr className="custom-hr" />
      <div className="mx">
        <div className="footer-container">
          <div className="footer-content flex-item">
            <div className="footer-second-content flex-item">
              {/* <div className="app-icon flex-item">
                <AppStoreIcon />
                <GooglePayIcon />
              </div> */}

              <div>
                <h3>
                  Copyright © 2025
                  <a href="https://godriveauto.ca/" style={{ color: "#e61717" }}>
                    {" "}
                    Go Drive Auto
                  </a>
                  . All rights reserved.
                </h3>
                <p>
                  OMVIC Registered Location: 2-17 Queen Street, Langton, ON N0E
                  1G0 (connect with google){" "}
                </p>
              </div>
              <div>
              <a href="https://godriveauto.ca/" >

                <img src={copy} className="koloo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
